import type { SchemaCreditRequestForm } from './schemas/creditRequestForm.schema';

export const DISPOSITIONSKREDIT = 'dispositionskredite';
export type DISPOSITIONSKREDIT_TYPE = typeof DISPOSITIONSKREDIT;
export const GESCHAEFTSKREDIT = 'geschaeftskredite';
export type GESCHAEFTSKREDIT_TYPE = typeof GESCHAEFTSKREDIT;
export const KREDITKARTE = 'kreditkarten';
export type KREDITKARTE_TYPE = typeof KREDITKARTE;
export const RATENKREDIT = 'ratenkredite';
export type RATENKREDIT_TYPE = typeof RATENKREDIT;
export const SONSTIGE_VERBINDLICHKEITEN = 'sonstigeVerbindlichkeiten';
export type SONSTIGE_VERBINDLICHKEITEN_TYPE = typeof SONSTIGE_VERBINDLICHKEITEN;
export const LEASING = 'leasings';
export type LEASING_TYPE = typeof LEASING;
export const KONTOKORRENTKREDIT = 'kontokorrentkredite';
export type KONTOKORRENTKREDIT_TYPE = typeof KONTOKORRENTKREDIT;
export const IMMOBILIENDARLEHEN = 'immobiliendarlehen';
export type IMMOBILIENDARLEHEN_TYPE = typeof IMMOBILIENDARLEHEN;

export const LoanTypeKeys: LoanType[] = [
    DISPOSITIONSKREDIT,
    GESCHAEFTSKREDIT,
    KREDITKARTE,
    RATENKREDIT,
    SONSTIGE_VERBINDLICHKEITEN,
    LEASING,
    KONTOKORRENTKREDIT,
    IMMOBILIENDARLEHEN,
];

export type LoanType = Extract<
    keyof SchemaCreditRequestForm,
    | 'dispositionskredite'
    | 'geschaeftskredite'
    | 'kreditkarten'
    | 'ratenkredite'
    | 'sonstigeVerbindlichkeiten'
    | 'leasings'
    | 'kontokorrentkredite'
    | 'immobiliendarlehen'
>;
export type RefinanceableLoanType = Exclude<LoanType, LEASING_TYPE | KONTOKORRENTKREDIT_TYPE>;
export type InstallmentLoanType =
    | RATENKREDIT_TYPE
    | GESCHAEFTSKREDIT_TYPE
    | IMMOBILIENDARLEHEN_TYPE
    | SONSTIGE_VERBINDLICHKEITEN_TYPE;
export type CreditLineLoanType = DISPOSITIONSKREDIT_TYPE | KREDITKARTE_TYPE | KONTOKORRENTKREDIT_TYPE;
export type Action = 'remove' | 'add' | 'change';
export type ActionTranslationPath = 'REMOVE' | 'ADD' | 'CHANGE';
export type LiabilityType =
    | 'LiabilityInstallmentCredit'
    | 'LiabilityBusinessCredit'
    | 'LiabilityCreditCard'
    | 'LiabilityOverdraft'
    | 'LiabilityOther'
    | 'LiabilityLeasing'
    | 'LiabilityOverdraftBusiness'
    | 'LiabilityRealEstateLoan';

export type Credit =
    | SchemaCreditRequestForm[DISPOSITIONSKREDIT_TYPE][number]
    | SchemaCreditRequestForm[GESCHAEFTSKREDIT_TYPE][number]
    | SchemaCreditRequestForm[KREDITKARTE_TYPE][number]
    | SchemaCreditRequestForm[RATENKREDIT_TYPE][number]
    | SchemaCreditRequestForm[SONSTIGE_VERBINDLICHKEITEN_TYPE][number]
    | SchemaCreditRequestForm[LEASING_TYPE][number]
    | SchemaCreditRequestForm[KONTOKORRENTKREDIT_TYPE][number];

export type SalaryValues = {
    lastMonthSalaryApplicant1: number | null | undefined;
    lastMonthSalaryApplicant2: number | null | undefined;
    salary1MonthAgoApplicant1: number | null | undefined;
    salary1MonthAgoApplicant2: number | null | undefined;
    salary2MonthAgoApplicant1: number | null | undefined;
    salary2MonthAgoApplicant2: number | null | undefined;
};
